<template>
    <div class="h-preview-image" v-if="dialogVisible">
        <span class="h-preview h-preview_close" @click="onClose">
            <i class="h-icon-close"></i>
        </span>
        <template v-if="srcList.length>1">
            <span class="h-preview h-preview-left" @click="onArrow('left')">
                <i class="h-icon-arrow-left"></i>
            </span>
            <span class="h-preview h-preview-right" @click="onArrow('right')">
                <i class="h-icon-arrow-right"></i>
            </span>
        </template>
        <div class="h-preview-main">
            <img 
                ref="previewImg" 
                class="h-preview_img" 
                :src="srcImage" alt="" srcset=""
                @wheel="wheel($event)"
                @mousedown.prevent="mouseStart($event)"
                @mousemove.prevent="mouseMove($event)"
                @mouseup.prevent="mouseEnd()"
                >
            <span class="h-preview_buttom">
                <i @click="zoom('in')" class="h-icon-zoom-in"></i>
                <i @click="zoom('out')" class="h-icon-zoom-out"></i>
                <i @click="transform('right')" class="h-icon-refresh-right" ></i>
                <i @click="transform('left')" class="h-icon-refresh-left"></i>
                <i @click="downloadFile()" class="h-icon-download"></i>
            </span>
        </div>
    </div>
</template>

<script>
// 定义变量
let zooms = 1;
let rotate = 0;
let startX = 0;
let startY = 0;
let translateX = 0;
let translateY = 0;
let lastX = 0;
let lastY = 0;
export default {
    name:"h-preview-image",
    props:{
        visible:{
            type:Boolean,
            default:()=>false
        },
        srcList:{
            type:Array,
            default:()=>[]
        },
        current:{
            type:[Number,String],
            default:()=>''
        }
    },
    data() {
        return {
            dialogVisible:false,
            currentSrc:'',
            isMove:false,
            srcImage:''
        }
    },
    
    mounted(){
        if(typeof(this.current) == 'number'){
            this.srcImage = this.srcList[this.current];
        }else{
            this.srcImage = this.current;
        }
    },
    methods: {
        zoom(type){
            if(type == 'in'){
                zooms +=0.1
            }else{
                if(zooms>0.4){
                    zooms -=0.1
                }
            }
            this.$refs.previewImg.style.transform = `scale(${zooms})`
        },
        transform(type){
            if(type=='left'){
                rotate -=90
            }else{
                rotate +=90
            }
            this.$refs.previewImg.style.transform = `rotate(${rotate}deg)`
        },
        // 控制鼠标缩放事件
        wheel(event){
            if(event.wheelDelta>0){
                this.zoom('in')
            }else{
                this.zoom('out')
            }
        },
        // 鼠标移入目标事件
        mouseStart(event){
            this.isMove = true;
            startX = event.pageX;
            startY = event.pageY;
        },
        // 鼠标拖动目标事件
        mouseMove(event){
            if(this.isMove){
                translateX = lastX + event.pageX - startX;
                translateY = lastY + event.pageY - startY;
                this.$refs.previewImg.style.transform = `translate(${translateX}px,${translateY}px) scale(${zooms})`;
            }
        },
        // 鼠标停止拖动目标事件
        mouseEnd(){
            this.isMove = false;
            lastX = translateX;
            lastY = translateY;
        },
        onArrow(type){
            if(type == 'right'){
                this.srcList.some((v,i)=>{
                    if(v == this.srcImage){
                        this.srcImage = this.srcList[i+1];
                        if(i === this.srcList.length - 1){
                            this.srcImage = this.srcList[0]
                            return true
                        }
                        return true
                    }
                })
            }else{
                this.srcList.some((v,i)=>{
                    if(v == this.srcImage){
                        this.srcImage = this.srcList[i-1];
                        if(i === 0){
                            this.srcImage = this.srcList[this.srcList.length-1]
                            return true
                        }
                        return true
                    }
                })
            }
        },
        downloadFile(){
            window.open(this.currentSrc,'_self')
        },
        onClose(){
            this.dialogVisible = false;
            this.$emit('update:visible', this.dialogVisible);
            this.$emit('close',this.dialogVisible);
        }
    },
    watch:{
        visible(val){
            this.dialogVisible = val
        },
    },
}
</script>

<style scoped lang="less">
.h-preview-image{
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    overflow: hidden;
    z-index: 99;
    .h-preview-main{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        img{
            max-height: 100%;
            max-width: 100%;
        }
    }
    .h-preview{
        z-index: 99;
        background: #606266;
        border-radius: 50%;
        padding: 10px;
        cursor: pointer;
        i{
            color: #fff;
        }
        &:hover{
            background: #909399;
        }
        &.h-preview_close{
            position: absolute;
            top: 20px;
            right: 20px;
        }
        &.h-preview-left{
            position: absolute;
            top: 50%;
            transform: translateX(-50%);
            left: 40px;
        }
        &.h-preview-right{
            position: absolute;
            top: 50%;
            transform: translateX(-50%);
            right: 20px;
        }
    }
    .h-preview_buttom{
        background: #606266;
        border-radius: 20px;
        padding: 10px;
        cursor: pointer;
        position: absolute;
        bottom: 20px;
        left: 50%;
        height: 20px;
        transform: translateX(-50%);
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        i{
            color: #fff;
            margin: 0 5px;
            font-size: 18px;
        }
    }
}
.h-icon-close:before {
    content: "\e6db";
}
.h-icon-arrow-left:before {
    content: "\e6de";
}
.h-icon-arrow-right:before {
    content: "\e6e0";
}
.h-icon-zoom-in:before {
    content: "\e777";
}
.h-icon-zoom-out:before {
    content: "\e776";
}
.h-icon-refresh-right:before {
    content: "\e6c8";
}
.h-icon-refresh-left:before {
    content: "\e6c7";
}
.h-icon-download:before {
    content: "\e77c";
}
[class^=h-icon-] {
    font-family: element-icons!important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
